var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 6.66667C5.7 6.66667 6.014 6.536 6.27533 6.27467C6.53622 6.01378 6.66667 5.7 6.66667 5.33333C6.66667 4.96667 6.53622 4.65267 6.27533 4.39133C6.014 4.13044 5.7 4 5.33333 4C4.96667 4 4.65289 4.13044 4.392 4.39133C4.13067 4.65267 4 4.96667 4 5.33333C4 5.7 4.13067 6.01378 4.392 6.27467C4.65289 6.536 4.96667 6.66667 5.33333 6.66667ZM5.33333 11.5667C6.68889 10.3222 7.69444 9.19156 8.35 8.17467C9.00556 7.15822 9.33333 6.25556 9.33333 5.46667C9.33333 4.25556 8.94711 3.26378 8.17467 2.49133C7.40267 1.71933 6.45556 1.33333 5.33333 1.33333C4.21111 1.33333 3.26378 1.71933 2.49133 2.49133C1.71933 3.26378 1.33333 4.25556 1.33333 5.46667C1.33333 6.25556 1.66111 7.15822 2.31667 8.17467C2.97222 9.19156 3.97778 10.3222 5.33333 11.5667ZM5.33333 13.3333C3.54444 11.8111 2.20844 10.3971 1.32533 9.09133C0.441778 7.786 0 6.57778 0 5.46667C0 3.8 0.536222 2.47222 1.60867 1.48333C2.68067 0.494444 3.92222 0 5.33333 0C6.74444 0 7.986 0.494444 9.058 1.48333C10.1304 2.47222 10.6667 3.8 10.6667 5.46667C10.6667 6.57778 10.2251 7.786 9.342 9.09133C8.45844 10.3971 7.12222 11.8111 5.33333 13.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.8a0cb2d41451b4eecffc77a1fb61d589.svg";
export { ForwardRef as ReactComponent };